import { Card } from '../../common/Card';
import { Ruler, Polygon, PencilLine, Trash } from 'phosphor-react';

export const ToolsPanel = ({
  activeTool,
  onToolSelect,
  onClearDrawings,
  showDecorations,
  onToggleDecorations,
  kidMode,
  onToggleKidMode
}) => {
  const tools = [
    { id: 'distance', name: 'قياس المسافة', icon: Ruler, emoji: '📏' },
    { id: 'area', name: 'قياس المساحة', icon: Polygon, emoji: '📐' },
    { id: 'draw', name: 'الرسم', icon: PencilLine, emoji: '🖍️' }
  ];

  const activeToolLabel = tools.find((tool) => tool.id === activeTool)?.name;

  return (
    <Card className="p-4 map-panel-card">
      <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
        <span>🛠️</span>
        أدوات اللعب بالخريطة
      </h3>
      <div className="space-y-2">
        {tools.map((tool) => {
          const Icon = tool.icon;
          const isActive = activeTool === tool.id;

          return (
            <button
              key={tool.id}
              onClick={() => onToolSelect(isActive ? null : tool.id)}
              className={`map-tool-btn ${isActive ? 'map-tool-btn-active' : ''}`}
            >
              <span className="text-lg">{tool.emoji}</span>
              <Icon size={22} weight={isActive ? 'fill' : 'regular'} />
              <span className="font-semibold">{tool.name}</span>
            </button>
          );
        })}
      </div>

      <label className="mt-3 flex items-center justify-between text-xs font-semibold text-gray-700 map-soft-box">
        <span>عرض الرسومات والأيقونات</span>
        <input
          type="checkbox"
          checked={showDecorations}
          onChange={() => onToggleDecorations(!showDecorations)}
          className="w-4 h-4"
        />
      </label>

      <label className="mt-2 flex items-center justify-between text-xs font-semibold text-gray-700 map-soft-box">
        <span>وضع الأطفال الملون</span>
        <input
          type="checkbox"
          checked={kidMode}
          onChange={() => onToggleKidMode(!kidMode)}
          className="w-4 h-4"
        />
      </label>

      <button
        type="button"
        onClick={onClearDrawings}
        className="w-full mt-3 flex items-center justify-center gap-2 rounded-xl border border-sky-200 px-3 py-2 text-xs font-semibold text-sky-700 hover:bg-sky-50"
      >
        <Trash size={16} />
        حذف الرسومات
      </button>

      {activeToolLabel && (
        <p className="text-[11px] text-gray-600 leading-relaxed mt-2">
          اخترت: <span className="font-semibold">{activeToolLabel}</span> - ابدأ بالرسم على الخريطة الآن.
        </p>
      )}
    </Card>
  );
};
